/*
 * @Author: your name
 * @Date: 2021-03-08 11:02:57
 * @LastEditTime: 2021-03-18 14:49:32
 * @LastEditors: your name
 * @Description: In User Settings Edit
 * @FilePath: /Workbench_Front_Support/src/workbench_front/pub/js/navNodeIcons.js
 */
const NodeIcons = {
    'default': 'default.svg',
    'caiziguanli': 'caiziguanli.svg',
    'caiwukuaiji': 'caiwukuaiji.svg',
    'dongtaijianmopingtai': 'dongtaijianmopingtai.svg',
    'gongxiangfuwu': 'gongxiangfuwu.svg',
    'gongyinglian': 'gongyinglian.svg',
    'guanlikuaiji': 'guanlikuaiji.svg',
    'jichengpingtai': 'jichengpingtai.svg',

    'jichushezhi': 'jichushezhi.svg',
    'richangcaozuo': 'richangcaozuo.svg',
    'wodezuoye': 'wodezuoye.svg',
    'yingyongguanlipingtai': 'yingyongguanlipingtai.svg',
    'yusuanbaobiao': 'yusuanbaobiao.svg',
    'zichanguanli': 'zichanguanli.svg'
}
function exportModules(exports, modules) {
    let keys = Object.keys(modules);
    keys.forEach(key => {
        Object.defineProperty(exports, key, {
            configurable: false,
            enumerable: true,
            get() {
                return require('Assets/images/nodeicons/' + modules[key]);
            }
        });
    });
}
exportModules((exports.optimize = {}), NodeIcons);
